import React, { useEffect, useState } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector} from "react-redux";
import useFetch from "../../../hooks/useFetch";

const HAFHTransportList = ({ t, role, hostelCode }) => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [transportList, setTransportList] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("ALL");
  const transportTypes = ["BUS", "VAN", "CAR", "AUTO", "TEMPO", "MINI_BUS", "OTHER"];
  const statusFilters = ["ACTIVE", "INACTIVE", "UNDER_MAINTENANCE", "EXPIRED_DOCUMENT", "OUT_OF_SERVICE"];

  const fetchTransport = async () => {
    try {

      const res = await fetchData({
        url: "/hafh/operations/transport/my",
        method: "post",
        data: { transportCode: userCode },
        headers: { Authorization: authState.token },
      });

      if (res?.status) setTransportList(res.records || []);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (hostelCode) fetchTransport();
  }, [hostelCode]);

  const filtered = selectedFilter === "ALL"
    ? transportList
    : transportList.filter((t) => t.transportType === selectedFilter || t.operationalStatus === selectedFilter);

  return (
    <div className="bg-gray-900 p-5 rounded-xl text-white space-y-4">
      <h2 className="text-cyan-300 text-lg font-bold">🚌 Hostel Transport List</h2>
      <div className="grid grid-cols-3 lg:grid-cols-7 gap-1">
        <button
          onClick={() => setSelectedFilter("ALL")}
          className={`px-1 py-2 rounded-md text-xs ${selectedFilter === "ALL" ? "bg-teal-600" : "bg-gray-700"}`}
        >
          ALL
        </button>
        {[...transportTypes, ...statusFilters].map((f) => (
          <button
            key={f}
            onClick={() => setSelectedFilter(f)}
            className={`px-1 py-2 rounded-md text-xs ${selectedFilter === f ? "bg-teal-600" : "bg-gray-700"}`}
          >
            {f}
          </button>
        ))}
      </div>
      <div className="space-y-3 mt-4">
        {filtered.length === 0 ? (
          <div className="text-gray-400 text-sm">No transport records found</div>
        ) : (
          filtered.map((t) => (
            <div key={t._id} className="bg-gray-800 p-4 rounded-xl border border-gray-700 space-y-2">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-cyan-300 font-semibold">{t.transportName}</div>
                  <div className="text-xs text-gray-400">Code: {t.transportCode}</div>
                </div>
                <div className="text-xs text-yellow-300">{t.transportType}</div>
              </div>
              <div className="text-sm text-gray-300">🚘 {t.vehicleBrand || "N/A"} {t.vehicleModel || ""}</div>
              <div className="text-xs text-gray-400">Vehicle No: {t.vehicleNumber || "N/A"}</div>
              <div className="text-xs text-gray-300">Capacity: {t.vehicleCapacity || 0} Seats</div>
              <div className="text-xs text-teal-300">📍 {t.startLocation || "N/A"} → {t.endLocation || "N/A"}</div>
              <div className="text-xs text-gray-400">Route: {t.routeName || "N/A"}</div>
              <div className="text-xs text-blue-300">👨‍✈️ Driver: {t.driverName || "N/A"} {" | "} 📞 {t.driverContact || "N/A"}</div>
              {t.helperName && (
                <div className="text-xs text-purple-300">🧑 Helper: {t.helperName}</div>
              )}
              <div className="text-xs text-gray-300">Transporter: {t.transporterName || "N/A"}</div>
              <div className="text-xs">Status: <span className="text-green-300">{t.operationalStatus}</span></div>
              <div className="flex flex-wrap gap-2 text-xs">
                {t.gpsEnabled && <div className="text-cyan-300">📡 GPS</div>}
                {t.cctvEnabled && <div className="text-red-300">🎥 CCTV</div>}
                {t.firstAidAvailable && <div className="text-green-300">⛑ First Aid</div>}
                {t.fireExtinguisherAvailable && <div className="text-orange-300">🔥 Fire Safety</div>}
                {t.panicButtonEnabled && <div className="text-pink-300">🚨 Panic Button</div>}
              </div>
              {t.pickupPoints?.length > 0 && (
                <div className="mt-2">
                  <div className="text-xs text-yellow-300 mb-1">Pickup Points:</div>
                  <div className="flex flex-wrap gap-1">
                    {t.pickupPoints.map((p, i) => (
                      <span key={i} className="text-xs bg-gray-700 px-2 py-1 rounded">
                        {p.pointName}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {t.tags?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1">
                  {t.tags.map((tag, i) => (
                    <span key={i} className="text-xs bg-gray-700 px-2 py-1 rounded">
                      #{tag}
                    </span>
                  ))}
                </div>
              )}

              <div className="flex flex-wrap gap-2 text-xs">
                {t.isPinned && <div className="text-yellow-300">📌 Priority Vehicle</div>}
              </div>

              <div className="flex gap-2 mt-3">
                <button className="px-3 py-1 bg-blue-600 text-xs rounded">View</button>
                <button className="px-3 py-1 bg-green-600 text-xs rounded">Edit</button>
                <button className="px-3 py-1 bg-purple-600 text-xs rounded">Share</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HAFHTransportList;